/**
 * Copyright © RINIS 2026
 * Licensed under the EUPL
 */

import * as TomSelect from 'tom-select'

enablePeerSelectInstances()

document.body.addEventListener('htmx:afterSettle', function () {
  enablePeerSelectInstances()
});

function enablePeerSelectInstances() {
  document
    .querySelectorAll('.peer-select')
    .forEach((el) => {
      let settings = {
        valueField: 'peer_id',
        labelField: 'peer_name',
        searchField: ['peer_name', 'peer_id'],
        sortField: [
          {field: 'peer_name', direction: 'asc'},
        ],
        preload: true,
        load: function(query, callback) {
          let self = this;

          if (self.loading > 1) {
            callback();
            return;
          }

          fetch('/peer-select')
            .then(response => response.json())
            .then(json => {
              callback(json);
              self.settings.load = null;
            }).catch(()=> {
            callback();
          });

        },
        render: {
          item: function (item, escape) {
            const peerName = item.peer_name
            const peerID = item.peer_id

            if (peerName && peerName !== '') {
              return '<div>' + escape(peerName) + '</div>';
            }

            return '<div>' + escape(peerID) + '</div>';
          },
          option: function(item, escape) {
            const peerName = item.peer_name
            const peerID = item.peer_id

            if (peerName && peerName !== '') {
              return '<div>' +
                '<span class="label">' + escape(peerName) + '</span>' +
                '<small class="caption">' + escape(peerID) + '</small>' +
              '</div>';
            }

            return '<div>' +
              '<span class="label">' + escape(peerID) + '</span>' +
              '</div>';
          }
        },
      };

      const select = new TomSelect(el, settings);

      select.on('load', function (loadedItems) {
        const self = this

        if (!loadedItems || !self.items || !self.items[0]) {
          return
        }

        const selectedItem = loadedItems.find(function (item) {
          return item.peer_id === self.items[0];
        })

        self.updateOption(selectedItem.peer_id, selectedItem);
      });
    });
}
